import $ from 'jquery';
import _ from 'underscore';
import MenuAim from '../../core/menuAim';
import { getStorage } from '../../helpers/storage-factory';
import { uncloakElement } from '../../../home24-desktop/layout/links';
import { setSubMenuHeight, setSubmenuVerticalPosition } from './mainmenu-layout';
import * as config from 'client/legacy/home24/core/config';

/**
 * Page Main Menu
 */
export default class MainMenu {
    constructor(c) {
        this.selectors = {
            topNavContainer: 'div.main-navigation-wrapper',
            topNavLinks: 'ul.main-navigation a.js-top-nav-link',
            topNavItems: 'ul.main-navigation>li',
            subMenu: '#main-sub-menu',
            subMenuArrow: '#main-sub-menu>.arrow',
            subMenuContentPlaceholder: '#main-sub-menu-placeholder',
            subMenuTemplate: '.sub-menu-template',
            subMenuLinks: '#main-sub-menu ul.sub-menu-list li>a, #main-sub-menu ul.sub-menu-list li>span',
            subMenuItems: 'ul.sub-menu-list>li',
            subMenu2: '#main-sub-menu-2',
            subMenu2Template: '.sub-menu-2-template',
            subMenu2Mock: '#main-sub-menu-2-mock',
            subMenu2Indicator: '#main-sub-menu-2-mock .loading-indicator',
            transparentOverflow: '.screen-transparent-overflow'
        };

        this.openMenuDelay = 200;
        this.$currentTarget = null;

        this.arrowX = 0;

        this.init(c || {});
    }

    /**
     * @param {String} selectorId
     */

    getSelectorById(selectorId) {
        if (!_.isUndefined(this.selectors[selectorId])) {
            return this.selectors[selectorId];
        }

        return false;
    }

    /**
     * @param {String} selectorId
     * @return {Object[]|Object|$}
     */
    getElementBySelectorById(selectorId) {
        return $(this.selectors[selectorId]);
    }

    init() {
        new MenuAim({
            parentSelector: this.getElementBySelectorById('topNavContainer'),
            menuSelector: this.getElementBySelectorById('subMenu'),
            options: {
                // Function to call when a row is purposefully activated. Use this
                // to show a submenu's content for the activated row.
                activate: $.proxy(this.onSubMenuItemActivate, this),

                // Function to call when a row is deactivated.
                deactivate: $.proxy(this.onSubMenuItemDeactivate, this),

                // Function to call when mouse exits the entire menu. If this returns
                // true, the current row's deactivation event and callback function
                // will be fired. Otherwise, if this isn't supplied or it returns
                // false, the currently activated row will stay activated when the
                // mouse leaves the menu entirely.
                exitMenu: $.proxy(this.onExitMenu, this),

                // Selector for identifying which elements in the menu are rows
                // that can trigger the above events. Defaults to "> li".
                rowSelector: this.getSelectorById('subMenuLinks'),
                submenuSelector: this.getSelectorById('subMenu2'),

                // Direction the submenu opens relative to the main menu. This
                // controls which direction is "forgiving" as the user moves their
                // cursor from the main menu into the submenu. Can be one of "right",
                // "left", "above", or "below". Defaults to "right".
                submenuDirection: 'right'
            }
        });

        this.req = null;
        this.storage = getStorage('memoryStorage');
        this.menuContainerWidth = this.getElementBySelectorById('topNavContainer').width();
        this.subMenuArrowWidth = this.getElementBySelectorById('subMenuArrow').outerWidth();
        this.menuWidth = this.getElementBySelectorById('subMenuContentPlaceholder').outerWidth();
        this.menuWidthExpanded = this.menuWidth;
        this.ajaxUrl = config.getBaseUrl() + '/category/get-categories/id/';
        this.rowItemTimer = null;
        this.rowItemDelay = config.getInt('navigation.hoverDelay');

        this.getElementBySelectorById('topNavLinks')
            .on('touchend', $.proxy(this.switchNavMenu, this));

        this.getElementBySelectorById('topNavLinks')
            .on('mouseenter-not-touch', $.proxy(this.triggerOpenMenu, this));

        this.getElementBySelectorById('topNavContainer')
            .on('mouseleave-not-touch', $.proxy(this.triggerCloseMenu, this));

        this.getElementBySelectorById('topNavContainer').find('.top.home')
            .on('mouseenter-not-touch', $.proxy(this.onExitMenu, this));

        this.getElementBySelectorById('transparentOverflow')
            .on('touchend', $.proxy(this.touchCloseMenu, this));
    }

    touchCloseMenu(event) {
        event.preventDefault();

        this.triggerCloseMenu(event);
    }

    switchNavMenu(event) {
        if ($(event.currentTarget).parent(this.getSelectorById('topNavItems')).hasClass('active')) {
            this.triggerCloseMenu(event);
        } else {
            this.triggerOpenMenu(event);
        }
    }

    triggerOpenMenu(event) {
        var self = this;

        var openMenu = function () {
            self.$currentTarget = $(event.currentTarget);
            self.showSubMenu(self.$currentTarget, event);
            self.$currentTarget.parent(self.getSelectorById('topNavItems')).addClass('active');
        };

        if (self.$currentTarget) {
            self.$currentTarget.parent(self.getSelectorById('topNavItems')).removeClass('active');
            openMenu();
        } else {
            clearTimeout(self.openMenuTimeout);
            self.openMenuTimeout = setTimeout(openMenu, self.openMenuDelay);
        }
    }

    triggerCloseMenu(event) {
        var $toElement;

        if (event.toElement) {
            $toElement = $(event.toElement);
        }

        if (!$toElement || !$toElement.is(this.getSelectorById('subMenu')) && !$toElement.parent(this.getSelectorById('subMenu')).length > 0) {
            this.onExitMenu(null, event);
        }

        if (this.openMenuTimeout) {
            clearTimeout(this.openMenuTimeout);
        }
        this.$currentTarget = null;

        this.getElementBySelectorById('transparentOverflow').hide();
    }

    /**
     *'callback' is optional
     */
    onSubMenuItemActivate(row, callback) {
        var $row = $(row);
        var hasSubCategories = $row.data('hasSubCategories') ? $row.data('hasSubCategories') : $row.children('[data-selector]').data('hasSubCategories');
        var categoryId = $row.data('categoryId') ? $row.data('categoryId') : $row.children('[data-selector]').data('categoryId');

        if (hasSubCategories) {
            this.showSubMenu2($(row), categoryId);
        }

        if (callback) {
            callback(hasSubCategories);
        }
    }

    onSubMenuItemDeactivate() {
        clearTimeout(this.rowItemTimer);
        this.hideSubMenu2();
    }

    onExitMenu(target, event) {
        if (!event) {
            return;
        }

        clearTimeout(this.openMenuTimeout);

        event.preventDefault();

        var $toElement;

        if (event.toElement) {
            $toElement = $(event.toElement);
        }

        if (!$toElement || !$toElement.is(this.getSelectorById('topNavContainer')) && !$toElement.parent(this.getSelectorById('topNavContainer')).length > 0) {
            this.hideSubMenu();

            if (this.$currentTarget) {
                this.$currentTarget.parent(this.getSelectorById('topNavItems')).removeClass('active');
            }
        }
    }

    showSubMenu($menuItem, event) {
        var $subMenu = this.getElementBySelectorById('subMenu');
        var $subMenu2 = this.getElementBySelectorById('subMenu2');
        var $template = $menuItem.parent(this.getSelectorById('topNavItems')).find(this.getSelectorById('subMenuTemplate'));
        var templateHtml = $template.html() || '';
        var $contentPlaceholder = this.getElementBySelectorById('subMenuContentPlaceholder');

        this.tweakPosition = false;
        this.hideSubMenu2();
        $contentPlaceholder.html(templateHtml);

        // TODO: ms edge hover fix, https://jira.home24.de/browse/REBOOT-21216
        this._uncloakLinks($contentPlaceholder);

        if (templateHtml.length > 0) {
            event.preventDefault();

            this.getElementBySelectorById('transparentOverflow').show();
            this._positionMenu($menuItem);
            $subMenu.show();

            /**
             * @see REBOOT-15193
             */
            if ($subMenu.hasClass('navigation--full')) {
                setSubMenuHeight();
                setSubmenuVerticalPosition(this.arrowX);
            }

            if (!$menuItem.parent('li').hasClass('show-two-columns')) {
                $subMenu2.addClass('show-one-column');
                $subMenu2.removeClass('show-two-columns');
            } else {
                $subMenu2.removeClass('show-one-column');
                $subMenu2.addClass('show-two-columns');
            }

            this.$lastMenuItem = $menuItem;
        } else {
            $subMenu.hide();
        }
    }

    hideSubMenu() {
        this.getElementBySelectorById('subMenuContentPlaceholder').html('');
        this.getElementBySelectorById('subMenu').hide();
        this.getElementBySelectorById('subMenu2').hide();
        this.abortRequest();
    }

    showSubMenu2($subMenuItem, categoryId) {
        var me = this;
        var $subMenu = me.getElementBySelectorById('subMenu');
        var $subMenu2 = me.getElementBySelectorById('subMenu2');
        var mockWidth = parseFloat($subMenu2.css('width')) || $subMenu2.width();
        var submenuTemplate;

        me.abortRequest();

        me.getElementBySelectorById('subMenu2Mock')
            .stop(true)
            .css({
                width: 0,
                height: $subMenu.height() - 5,
                display: 'block'
            })
            .animate({
                width: mockWidth
            }, 75, function () {
                me.getElementBySelectorById('subMenu2Indicator').show();
            }).css({ overflow: 'visible' });

        $subMenu2.html('');

        submenuTemplate = me.storage.get(categoryId);

        if (submenuTemplate) {
            me._renderTemplate(submenuTemplate, $subMenu, $subMenuItem, $subMenu2);
        } else {

            me.rowItemTimer = setTimeout(function () {

                me.req = $.ajax({
                    method: 'GET',
                    url: me.ajaxUrl + categoryId,
                    dataType: 'json'
                }).fail(function () {
                    me.getElementBySelectorById('subMenu2Mock').css({
                        width: 0,
                        height: 0,
                        display: 'none'
                    }).stop(true);
                    me.hideSubMenu2();
                }).done(function (data) {
                    if ($.isPlainObject(data) && data.content) {
                        me.storage.set(categoryId, data.content);
                        me._renderTemplate(data.content, $subMenu, $subMenuItem, $subMenu2);
                    } else {
                        return;
                    }
                    me.req = null;
                });

            }, me.rowItemDelay);
        }
    }

    hideSubMenu2() {
        if (!this.tweakPosition) {
            this.getElementBySelectorById('subMenu').find(' li>a.active').removeClass('active');
            this.abortRequest();
            this.getElementBySelectorById('subMenu2').hide().html('');
        }
        this.tweakPosition = false;
    }

    abortRequest() {
        this.getElementBySelectorById('subMenu2Indicator').hide();
        this.getElementBySelectorById('subMenu2Mock').css({
            width: 0,
            height: 0,
            display: 'none'
        }).stop(true);
    }

    _positionMenu($menuItem) {
        var $subMenu = this.getElementBySelectorById('subMenu');
        var $subMenuArrow = this.getElementBySelectorById('subMenuArrow');
        var menuItemX = $menuItem.position().left;
        var menuItemWidth = $menuItem.outerWidth();
        var x;
        var arrowX;

        x = menuItemX + (menuItemWidth - this.menuWidth) / 2;

        if (x < 0) {
            // left menu point
            x = 0;
            arrowX = menuItemX + (menuItemWidth - this.subMenuArrowWidth) / 2;
        } else if (x >= this.menuContainerWidth - this.menuWidth) {
            // menu points in the middle
            x = this.menuContainerWidth - this.menuWidth - 3;
            arrowX = menuItemX - x + (menuItemWidth - this.subMenuArrowWidth) / 2;
        } else {
            // right menu point
            arrowX = (this.menuWidth - this.subMenuArrowWidth) / 2;
        }

        /**
         * @see REBOOT-15193
         */
        if (!$subMenu.hasClass('navigation--full')) {
            $subMenu.css('left', x);
        } else {
            arrowX = arrowX + x;
        }

        this.arrowX = arrowX;

        $subMenuArrow.css('left', arrowX);
    }

    _renderTemplate(templateHtml, $subMenu, $subMenuItem, $subMenu2) {
        var $subMenuArrow = this.getElementBySelectorById('subMenuArrow');
        var newX;

        $subMenu.find(' li>a.active').removeClass('active');
        $subMenuItem.addClass('active');

        $subMenu2.html(templateHtml);
        this.menuWidthExpanded = this.menuWidth + $subMenu2.outerWidth() + (parseFloat($subMenu.css('border-left-width')) || 1) + (parseFloat($subMenu.css('border-right-width')) || 1);

        if (templateHtml.length > 0) {
            var x = $subMenu.position().left;

            if (x + this.menuWidthExpanded >= this.menuContainerWidth) {
                this.tweakPosition = true;
                newX = this.menuContainerWidth - this.menuWidthExpanded;
                $subMenu.css('left', newX);
                $subMenuArrow.css('left', this.$lastMenuItem.position().left - newX + (this.$lastMenuItem.outerWidth() - this.subMenuArrowWidth) / 2);
            }

            this.getElementBySelectorById('subMenu2Mock').css({
                width: 0,
                height: 0,
                display: 'none'
            }).stop(true);
            $subMenu2.show();
        } else {
            this.hideSubMenu2();
        }
    }

    // TODO: ms edge hover fix, https://jira.home24.de/browse/REBOOT-21216
    _uncloakLinks($template) {
        $template.find('span[data-dma], div[data-dma]').each(function () {
            var $link = $(this);

            uncloakElement($link);
        });
    }
}



/** WEBPACK FOOTER **
 ** ./legacy/home24/modules/common/mainmenu.js
 **/